<template>

  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <!-- <sidebar-link to="/admin/overview">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>{{ $t('message.DASHBOARD') }}</p>
      </sidebar-link> -->

      <sidebar-link v-if="$can('view_truckers')" to="/admin/truckers">
        <i class="fa fa-users"></i>
        <p>{{ $t('message.TRUCKER')}}</p>
      </sidebar-link>

       <sidebar-link v-if="$can('view_prices')" to="/admin/price">
       <i class="fa fa-credit-card"></i>
        <p>{{ $t('message.PRICE')}}</p>
      </sidebar-link>

      <sidebar-link  v-if="$can('view_add_on')" to="/admin/add-ons">
        <i class="fa fa-plus-circle"></i>
        <p>{{ $t('message.ADD_ONS')}}</p>
      </sidebar-link>
 
      <sidebar-link to="/admin/user">
        <i class="fa fa-user"></i>
        <p>{{ $t('message.PROFILE')}}</p>
      </sidebar-link>


    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
